import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { AutosizeModule } from 'ngx-autosize';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { MomentModule } from 'ngx-moment';
import { ExpressionOfInterestExpiredNotificationCardComponent } from 'src/app/pages/manage-workers/components/expression-of-interest-expired-notification-card/expression-of-interest-expired-notification-card.component';
import { CreateGroupEligibleModal } from 'src/app/shared/components/create-group-eligible-modal/create-group-eligible-modal';
import { DateComponent } from 'src/app/shared/components/date/date.component';
import { DeviceSupportComponent } from 'src/app/shared/components/device-support/device-support.component';
import { ExpressPayStatusComponent } from 'src/app/shared/components/express-pay-status/express-pay-status.component';
import { ExpressionOfInterestDeclineNotificationCardComponent } from 'src/app/shared/components/expression-of-interest-decline-notification-card/expression-of-interest-decline-notification-card.component';
import { FlexJobDateTimeComponent } from 'src/app/shared/components/flex-job-date-time/flex-job-date-time.component';
import { IdentityVerificationModalComponent } from 'src/app/shared/components/identity-verification-modal/identity-verification-modal.component';
import { MableImageCropperComponent } from 'src/app/shared/components/image-cropper/image-cropper.component';
import { JobMatchExplanationComponent } from 'src/app/shared/components/job-match-explanation/job-match-explanation.component';
import { JobResponsesComponent } from 'src/app/shared/components/job-responses/job-responses.component';
import { JobSharedSuccessfullyComponent } from 'src/app/shared/components/job-shared-successfully/job-shared-successfully.component';
import { LoyaltyBadgeComponent } from 'src/app/shared/components/loyalty-badge/loyalty-badge.component';
import { ModalBackComponent } from 'src/app/shared/components/modal-back/modal-back.component';
import { NdisPriceLimitAlertComponent } from 'src/app/shared/components/ndis-price-limit-alert/ndis-price-limit-alert.component';
import { PublicHolidayCardComponent } from 'src/app/shared/components/public-holiday-card/public-holiday-card.component';
import { StepperHeaderComponent } from 'src/app/shared/components/stepper/stepper-header/stepper-header.component';
import { StepperStepComponent } from 'src/app/shared/components/stepper/stepper-step/stepper-step.component';
import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import { ViewDatesAndTimesSummaryComponent } from 'src/app/shared/components/support-needs/view-dates-and-times-summary/view-dates-and-times-summary.component';
import { TimeComponent } from 'src/app/shared/components/time/time.component';
import { UserExperienceConfirmationModalComponent } from 'src/app/shared/components/user-experience-confirmation-modal/user-experience-confirmation-modal.component';
import { UserExperienceFeedbackModalComponent } from 'src/app/shared/components/user-experience-feedback-modal/user-experience-feedback-modal.component';
import { UserExperienceImprovementFeedbackModalComponent } from 'src/app/shared/components/user-experience-improvement-feedback-modal/user-experience-improvement-feedback-modal.component';
import { VerifiedWorkerBadgeComponent } from 'src/app/shared/components/verified-worker-badge/verified-worker-badge.component';
import { VideoPlayerComponent } from 'src/app/shared/components/video-player/video-player.component';
import { ViewFormattedEditorTextComponent } from 'src/app/shared/components/view-formatted-editor-text/view-formatted-editor-text.component';
import { WorkerFlexJobListItemComponent } from 'src/app/shared/components/worker-flex-job-list-item/worker-flex-job-list-item.component';
import { AfterScrolledIntoViewDirective } from 'src/app/shared/directives/after-scrolled-into-view.directive';
import { SessionDismissibleButtonDirective } from 'src/app/shared/directives/session-dismissible-button.directive';
import { BackendIconPipe } from 'src/app/shared/pipes/backend-icon.pipe';
import { BSBNumberPipe } from 'src/app/shared/pipes/bsb-number.pipe';
import { PhoneNumberFormatterPipe } from 'src/app/shared/pipes/phone-number-formatter.pipe';
import { TimeblockNamePipe } from 'src/app/shared/pipes/timeblock-name.pipe';
import { NgxImageCompressService } from 'src/app/shared/services/ngx-image-compress/ngx-image-compress.service';
import { SwiperModule } from 'swiper/angular';
import { ToggleBlockUserDirective } from '../pages/conversation/directives/toggle-block-user.directive';
import { FulfillCancelReasonsModal } from '../pages/regular-jobs/view/consumer/fulfill-cancel-reasons-modal/fulfill-cancel-reasons-modal';
import { PlanSessionGuidanceComponent } from '../pages/scheduling/plan-session-guidance/plan-session-guidance.component';
import { AgreementStatusChipComponent } from './components/agreement-status-chip/agreement-status-chip.component';
import { AvatarGroupComponent } from './components/avatar-group/avatar-group.component';
import { BannerComponent } from './components/banner/banner.component';
import { BoosterReminderComponent } from './components/booster-reminder/booster-reminder.component';
import { ButtonComponent } from './components/button/button.component';
import { CarerListComponent } from './components/carer-list/carer-list.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { CheckboxGroupComponent } from './components/checkbox-group/checkbox-group.component';
import { CleanSlateContainerComponent } from './components/clean-slate/clean-slate-container/clean-slate-container.component';
import { CleanSlateComponent } from './components/clean-slate/clean-slate.component';
import { ClientRegularJobListItemComponent } from './components/client-regular-job-list-item/client-regular-job-list-item.component';
import { CodeOfConductModalComponent } from './components/code-of-conduct-modal/code-of-conduct-modal.component';
import { CollapsibleComponent } from './components/collapsible/collapsible.component';
import { ConfirmationPopoverComponent } from './components/confirmation-popover/confirmation-popover.component';
import { ContinueSharingComponent } from './components/continue-sharing/continue-sharing.component';
import { SharePromptComponent } from './components/continue-sharing/share-prompt/share-prompt.component';
import { DashboardFeatureTileComponent } from './components/dashboard/feature-tile/feature-tile.component';
import { DeleteAccountComponent } from './components/delete-account/delete-account.component';
import { DraftJobListItemComponent } from './components/draft-job-list-item/draft-job-list-item.component';
import { EmailCallContactComponent } from './components/email-call-contact/email-call-contact.component';
import { EventCalendarComponent } from './components/event-calendar/event-calendar.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { HeadingComponent } from './components/heading/heading.component';
import { HowItWorksComponent } from './components/how-it-works/how-it-works.component';
import { InfiniteScrollComponentMigrated } from './components/infinite-scroll-migrated/infinite-scroll.component';
import { InfiniteScrollComponent } from './components/infinite-scroll/infinite-scroll.component';
import { InputComponent } from './components/input/input.component';
import { Ionic4DatepickerModalComponent } from './components/ionic4-datepicker/ionic4-datepicker-modal/ionic4-datepicker-modal.component';
import { LiIonic4DatepickerDirective } from './components/ionic4-datepicker/li-ionic4-datepicker.directive';
import { JobFilterActionConfirmationComponent } from './components/job-filter-alert/job-filter-action-confirmation/job-filter-action-confirmation.component';
import { JobFilterSuccessMsgComponent } from './components/job-filter-alert/job-filter-success-msg/job-filter-success-msg.component';
import { JobSharedWithNamesComponent } from './components/job-shared-with-names/job-shared-with-names.component';
import { JobStatusChipsComponent } from './components/job-status-chips/job-status-chips.component';
import { AutoCompleteModalComponent } from './components/modals/auto-complete-modal/auto-complete-modal.component';
import { MomentDisplayModule } from './components/moment-display/moment-display.module';
import { NumericInputComponent } from './components/numeric-input/numeric-input.component';
import { PaymentOfferSuspensionComponent } from './components/payment-offer-suspension/payment-offer-suspension.component';
import { PaymentOfferWarningComponent } from './components/payment-offer-warning/payment-offer-warning.component';
import { PrivateJobListItemComponent } from './components/private-job-list-item/private-job-list-item.component';
import { RadioGroupComponent } from './components/radio-group/radio-group.component';
import { SetPasswordComponent } from './components/set-password/set-password.component';
import { SoftBanModalComponent } from './components/soft-ban-modal/soft-ban-modal.component';
import { StarRatingComponent } from './components/star-rating/star-rating.component';
import { SuburbSelectorModalInputComponent } from './components/suburb-selector/suburb-selector-modal-input/suburb-selector-modal-input.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions-modal/terms-and-conditions-modal.component';
import { TileGroupComponent } from './components/tile-group/tile-group.component';
import { UserAvatarGqlComponent } from './components/user-avatar-gql/user-avatar-gql.component';
import { UserAvatarComponent } from './components/user-avatar/user-avatar.component';
import { WorkerRegularJobListItemComponent } from './components/worker-regular-job-list-item/worker-regular-job-list-item.component';
import { WorkerServiceTermsComponent } from './components/worker-service/worker-service-terms/worker-service-terms.component';
import { WorkerServiceComponent } from './components/worker-service/worker-service/worker-service.component';
import { WorkerServicesComponent } from './components/worker-service/worker-services/worker-services.component';
import { AriaHiddenDirective } from './directives/aria-hidden.directive';
import { DeletePlannedSessionDirective } from './directives/delete-planned-session.directive';
import { MaxLengthDirective } from './directives/max-length.directive';
import { OpenLinkButtonDirective } from './directives/open-link-button.directive';
import { PhoneNumberFormatterDirective } from './directives/phone-number-formatter.directive';
import { ToggleChannelVisibilityDirective } from './directives/toggle-channel-visibility.directive';
import { UserAccountAlertsDirective } from './directives/user-account-alerts.directive';
import { VideoChatDirective } from './directives/video-chat.directive';
import { ViewMyProfileDirective } from './directives/view-my-profile.directive';
import { ViewOtherUserProfileDirective } from './directives/view-other-user-profile.directive';
import { WhitespaceOnRequiredDirective } from './directives/whitespace-on-required.directive';
import { FilenamePipe } from './pipe/filename.pipe';
import { AgeRangePipe } from './pipes/age-range.pipe';
import { AgreementStatusChipIconPipe } from './pipes/agreement-status-chip-icon.pipe';
import { AgreementStatusColorPipe } from './pipes/agreement-status-color.pipe';
import { AgreementStatusMapPipe } from './pipes/agreement-status-map.pipe';
import { ArrayToStringPipe } from './pipes/array-to-string.pipe';
import { ChannelNamePipe } from './pipes/channel-name.pipe';
import { ChannelParserPipe } from './pipes/channel-parser.pipe';
import { ChannelTypingIndicatorPipe } from './pipes/channel-typing-indicator.pipe';
import { CondensedNamesListPipe } from './pipes/condensed-names-list.pipe';
import { FlatRateMapPipe } from './pipes/flat-rate-map.pipe';
import { FormatFullMonth } from './pipes/format-full-month.pipe';
import { JobStatusColorPipe } from './pipes/job-status-color.pipe';
import { OnlineStatusPipe } from './pipes/online-status.pipe';
import { RemoveTimezoneFromDatePipe } from './pipes/remove-timezone-from-date.pipe';

@NgModule({
  imports: [
    MomentDisplayModule,
    ReactiveFormsModule,
    AutosizeModule,
    FormsModule,
    CommonModule,
    IonicModule,
    ModalBackComponent,
    MomentModule,
    SwiperModule,
    ImageCropperComponent,
    HeadingComponent,
    ButtonComponent,
    BannerComponent,
    ViewDatesAndTimesSummaryComponent,
    SessionDismissibleButtonDirective,
    RadioGroupComponent,
    TimeblockNamePipe,
    AriaHiddenDirective,
    LoyaltyBadgeComponent,
    UserAvatarComponent,
    VerifiedWorkerBadgeComponent,
    CollapsibleComponent,
    CleanSlateContainerComponent,
    CheckboxGroupComponent,
    DeletePlannedSessionDirective,
    InfiniteScrollComponentMigrated,
    CleanSlateComponent,
  ],
  declarations: [
    InputComponent,
    InfiniteScrollComponent,
    FlatRateMapPipe,
    AgreementStatusMapPipe,
    ViewMyProfileDirective,
    ViewOtherUserProfileDirective,
    CarerListComponent,
    VideoChatDirective,
    PrivateJobListItemComponent,
    WorkerRegularJobListItemComponent,
    ClientRegularJobListItemComponent,
    DraftJobListItemComponent,
    ContinueSharingComponent,
    SharePromptComponent,
    AvatarGroupComponent,
    JobSharedWithNamesComponent,
    FulfillCancelReasonsModal,
    SetPasswordComponent,
    ExpressPayStatusComponent,
    AgreementStatusChipComponent,
    UserAccountAlertsDirective,
    JobStatusChipsComponent,
    JobFilterActionConfirmationComponent,
    JobFilterSuccessMsgComponent,
    WorkerServiceComponent,
    WorkerServicesComponent,
    WorkerServiceTermsComponent,
    FileUploadComponent,
    FilenamePipe,
    DateComponent,
    TimeComponent,
    DashboardFeatureTileComponent,
    SuburbSelectorModalInputComponent,
    HowItWorksComponent,
    TileGroupComponent,
    OpenLinkButtonDirective,
    AutoCompleteModalComponent,
    ConfirmationPopoverComponent,
    LiIonic4DatepickerDirective,
    Ionic4DatepickerModalComponent,
    RemoveTimezoneFromDatePipe,
    EmailCallContactComponent,
    MaxLengthDirective,
    ChannelParserPipe,
    ChannelNamePipe,
    ToggleChannelVisibilityDirective,
    WhitespaceOnRequiredDirective,
    ArrayToStringPipe,
    ChannelTypingIndicatorPipe,
    PaymentOfferSuspensionComponent,
    NumericInputComponent,
    BoosterReminderComponent,
    CodeOfConductModalComponent,
    DeleteAccountComponent,
    ToggleBlockUserDirective,
    SoftBanModalComponent,
    TermsAndConditionsComponent,
    OnlineStatusPipe,
    PlanSessionGuidanceComponent,
    EventCalendarComponent,
    FormatFullMonth,
    PaymentOfferWarningComponent,
    CondensedNamesListPipe,
    AgeRangePipe,
    ViewFormattedEditorTextComponent,
    CarouselComponent,
    UserExperienceFeedbackModalComponent,
    IdentityVerificationModalComponent,
    UserExperienceImprovementFeedbackModalComponent,
    JobMatchExplanationComponent,
    NdisPriceLimitAlertComponent,
    AfterScrolledIntoViewDirective,
    PublicHolidayCardComponent,
    JobResponsesComponent,
    UserExperienceConfirmationModalComponent,
    JobSharedSuccessfullyComponent,
    CreateGroupEligibleModal,
    AgreementStatusColorPipe,
    AgreementStatusChipIconPipe,
    JobStatusColorPipe,
    BackendIconPipe,
    DeviceSupportComponent,
    ExpressionOfInterestDeclineNotificationCardComponent,
    ExpressionOfInterestExpiredNotificationCardComponent,
    PhoneNumberFormatterPipe,
    PhoneNumberFormatterDirective,
    StepperComponent,
    StepperHeaderComponent,
    StepperStepComponent,
    BSBNumberPipe,
    VideoPlayerComponent,
    MableImageCropperComponent,
    WorkerFlexJobListItemComponent,
    FlexJobDateTimeComponent,
    UserAvatarGqlComponent,
    StarRatingComponent,
  ],
  exports: [
    LiIonic4DatepickerDirective,
    InputComponent,
    InfiniteScrollComponent,
    InfiniteScrollComponentMigrated,
    FlatRateMapPipe,
    AgreementStatusMapPipe,
    CarerListComponent,
    ViewMyProfileDirective,
    ViewOtherUserProfileDirective,
    VideoChatDirective,
    PrivateJobListItemComponent,
    WorkerRegularJobListItemComponent,
    ClientRegularJobListItemComponent,
    DraftJobListItemComponent,
    MomentDisplayModule,
    ContinueSharingComponent,
    SharePromptComponent,
    AvatarGroupComponent,
    JobSharedWithNamesComponent,
    FulfillCancelReasonsModal,
    SetPasswordComponent,
    ExpressPayStatusComponent,
    AgreementStatusChipComponent,
    CheckboxGroupComponent,
    ModalBackComponent,
    WorkerServiceComponent,
    WorkerServicesComponent,
    WorkerServiceTermsComponent,
    ReactiveFormsModule,
    UserAccountAlertsDirective,
    JobStatusChipsComponent,
    JobFilterActionConfirmationComponent,
    JobFilterSuccessMsgComponent,
    FileUploadComponent,
    FilenamePipe,
    RadioGroupComponent,
    DateComponent,
    TimeComponent,
    FormsModule,
    CommonModule,
    IonicModule,
    // TODO: remove UserAvatarComponent when all done with gql
    UserAvatarComponent,
    DashboardFeatureTileComponent,
    SuburbSelectorModalInputComponent,
    CleanSlateComponent,
    CleanSlateContainerComponent,
    HeadingComponent,
    ButtonComponent,
    HowItWorksComponent,
    BannerComponent,
    TileGroupComponent,
    OpenLinkButtonDirective,
    AriaHiddenDirective,
    AutoCompleteModalComponent,
    ConfirmationPopoverComponent,
    RemoveTimezoneFromDatePipe,
    EmailCallContactComponent,
    MaxLengthDirective,
    ChannelParserPipe,
    ChannelNamePipe,
    ToggleChannelVisibilityDirective,
    WhitespaceOnRequiredDirective,
    ArrayToStringPipe,
    ChannelTypingIndicatorPipe,
    PaymentOfferSuspensionComponent,
    NumericInputComponent,
    BoosterReminderComponent,
    CodeOfConductModalComponent,
    DeleteAccountComponent,
    TermsAndConditionsComponent,
    ToggleBlockUserDirective,
    OnlineStatusPipe,
    PlanSessionGuidanceComponent,
    EventCalendarComponent,
    FormatFullMonth,
    PaymentOfferWarningComponent,
    MomentModule,
    CollapsibleComponent,
    AgeRangePipe,
    ViewFormattedEditorTextComponent,
    CarouselComponent,
    UserExperienceFeedbackModalComponent,
    IdentityVerificationModalComponent,
    UserExperienceImprovementFeedbackModalComponent,
    JobMatchExplanationComponent,
    NdisPriceLimitAlertComponent,
    AfterScrolledIntoViewDirective,
    DeletePlannedSessionDirective,
    PublicHolidayCardComponent,
    JobResponsesComponent,
    UserExperienceConfirmationModalComponent,
    JobSharedSuccessfullyComponent,
    CreateGroupEligibleModal,
    JobStatusColorPipe,
    BackendIconPipe,
    DeviceSupportComponent,
    ExpressionOfInterestDeclineNotificationCardComponent,
    ExpressionOfInterestExpiredNotificationCardComponent,
    PhoneNumberFormatterPipe,
    PhoneNumberFormatterDirective,
    StepperComponent,
    StepperStepComponent,
    BSBNumberPipe,
    VideoPlayerComponent,
    MableImageCropperComponent,
    ViewDatesAndTimesSummaryComponent,
    SessionDismissibleButtonDirective,
    WorkerFlexJobListItemComponent,
    FlexJobDateTimeComponent,
    UserAvatarGqlComponent,
    StarRatingComponent,
  ],
  providers: [NgxImageCompressService, RemoveTimezoneFromDatePipe],
})
export class SharedModule {}
